var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoaderOneDesktop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1467,
    height: 1043,
    viewBox: "0 0 1467 1043",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "loaderOne"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 1",
    filter: "url(#filter0_b_18_5852)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 478,
    width: 395,
    height: 422,
    rx: 8,
    fill: "#3B4856",
    fillOpacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 4",
    filter: "url(#filter1_b_18_5852)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 796,
    y: 478,
    width: 132,
    height: 190,
    rx: 4,
    fill: "#3B4856",
    fillOpacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 85",
    filter: "url(#filter2_b_18_5852)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 958,
    y: 479,
    width: 132,
    height: 190,
    rx: 4,
    fill: "#3B4856",
    fillOpacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 89",
    filter: "url(#filter3_b_18_5852)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1120,
    y: 480,
    width: 132,
    height: 190,
    rx: 4,
    fill: "#3B4856",
    fillOpacity: 0.3
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 76",
    x: 257,
    y: 522,
    width: 241,
    height: 147,
    rx: 4,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 96",
    x: 180,
    y: 190,
    width: 404,
    height: 97,
    rx: 4,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 95",
    x: 180,
    y: 442,
    width: 395,
    height: 29,
    rx: 4,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 93",
    x: 832,
    y: 210,
    width: 171,
    height: 66,
    rx: 4,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 94",
    x: 1048,
    y: 210,
    width: 171,
    height: 66,
    rx: 4,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 82",
    x: 826,
    y: 505,
    width: 72,
    height: 28,
    rx: 4,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 86",
    x: 988,
    y: 506,
    width: 72,
    height: 28,
    rx: 4,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 90",
    x: 1150,
    y: 507,
    width: 72,
    height: 28,
    rx: 4,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 84",
    x: 826,
    y: 613,
    width: 72,
    height: 28,
    rx: 4,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 87",
    x: 988,
    y: 614,
    width: 72,
    height: 28,
    rx: 4,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 91",
    x: 1150,
    y: 615,
    width: 72,
    height: 28,
    rx: 4,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 83",
    x: 839,
    y: 553,
    width: 46,
    height: 43,
    rx: 21.5,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 97",
    x: 424,
    y: 689,
    width: 46,
    height: 43,
    rx: 21.5,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 88",
    x: 1001,
    y: 554,
    width: 46,
    height: 43,
    rx: 21.5,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 92",
    x: 1163,
    y: 555,
    width: 46,
    height: 43,
    rx: 21.5,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 77",
    x: 284,
    y: 690,
    width: 131,
    height: 41,
    rx: 4,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 78",
    x: 234,
    y: 799,
    width: 111,
    height: 28,
    rx: 4,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 80",
    x: 412,
    y: 799,
    width: 111,
    height: 28,
    rx: 4,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 79",
    x: 234,
    y: 837,
    width: 111,
    height: 28,
    rx: 4,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 81",
    x: 412,
    y: 837,
    width: 111,
    height: 28,
    rx: 4,
    fill: "#E5E5E5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_18_5852",
    x: 176,
    y: 474,
    width: 403,
    height: 430,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_18_5852"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_18_5852",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_18_5852",
    x: 792,
    y: 474,
    width: 140,
    height: 198,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_18_5852"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_18_5852",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_18_5852",
    x: 954,
    y: 475,
    width: 140,
    height: 198,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_18_5852"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_18_5852",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_b_18_5852",
    x: 1116,
    y: 476,
    width: 140,
    height: 198,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_18_5852"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_18_5852",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaderOneDesktop);
export default __webpack_public_path__ + "static/media/loader-one-desktop.2f30f7b1fd544862fe81f131eee0128f.svg";
export { ForwardRef as ReactComponent };